import { Operation } from '../api/types';

/**
 * «Разовые» повседневные траты — крупные покупки вне дневного темпа.
 * С миграции 0010 разметка — колонка `operations.is_one_off` (общая для всех
 * устройств); мутация — `updateTx({id, is_one_off})` через офлайн-очередь.
 */
export function oneOffIdsFrom(operations: Operation[]): Set<string> {
  const s = new Set<string>();
  for (const op of operations) {
    if (op.is_one_off) s.add(op.id);
  }
  return s;
}

// ---------------------------------------------------------------------------
// Легаси-localStorage (до 0010) — читается только бэкфиллом миграции состояния.
// ---------------------------------------------------------------------------

export const LEGACY_ONE_OFF_KEY = 'one_off_ops';

export function readLegacyOneOffIds(): Set<string> {
  try {
    const raw = localStorage.getItem(LEGACY_ONE_OFF_KEY);
    if (!raw) return new Set();
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? new Set(arr as string[]) : new Set();
  } catch {
    return new Set();
  }
}
